import React, { useEffect, useState } from 'react'
import { InputCompo } from '../../../Components/InputCompo/InputCompo'
import { ParagraphComp } from '../../../Components/ParagraphComp/ParagraphComp'
import CustomInput from '../../../Components/InputCompo/CustomInput'
import * as Yup from 'yup';
import { useFormik } from 'formik';
import CustomSelection from '../../../Components/SelectionComp/CustomSelection';
import ButtonComp from '../../../Components/ButtonComp/ButtonComp';
import { Additionaldocuments as documents, AdditionalCheckBoxDocuments as CheckBoxDocuments, AdditionalParagraph as para } from "./Documents"
import { enqueueSnackbar } from 'notistack';
import { useMutation, useQuery } from '@tanstack/react-query';
import { EOIGet, ExpressionOfInterestRegistration } from '../../../Store/auth/register';
import { Typography } from '@mui/material';
import FinancialYearForm from './FinancialYear';
import ModalComp from '../../../Components/ModalComp';


const AddEOI = () => {

    const [initialValues, setInitialValues] = useState({});

    const gsnNoFromStorage = localStorage.getItem('gsn_no');


    const [financialYearsData, setFinancialYearsData] = useState([]);

    // Function to update financialYears in the parent component
    const handleFinancialYearsChange = (data) => {
      setFinancialYearsData(data);
    };


    const modelSchema = Yup.object().shape(
        documents.reduce((schema, field) => {
          let validator = Yup.string(); // Default to string validation
      
          if (field.validation) {
            switch (field.validation.toLowerCase()) {
              case 'email':
                validator = Yup.string().email('Invalid email address');
                break;
              case 'number':
                validator = Yup.string().matches(/^\d{10}$/, 'Invalid Number. It should be 10 digits.');
                break;
              case 'rupee':
                validator = Yup.string().matches(/^\d{2,20}$/, 'Invalid Number.');
                break;
              case 'pan':
                validator = Yup.string().matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, 'Invalid PAN Number. It should be in the format: ABCDE1234F.');
                break;
              case 'pincode':
                validator = Yup.string().matches(/^\d{4}$|^\d{6}$/, 'PIN code must be exactly 6 digits');
                break;
              case 'website':
                validator = Yup.string().url('Please enter a valid URL');
                break;
              case 'mobile':
                validator = Yup.string().matches(/^(?:[0-9]{10}|[0-9]{7})$/, 'Invalid contact number');
                break;
              case 'checkbox': // This case handles the checkbox validation
                validator = Yup.boolean().test('at-least-one-checked', 'Please check at least one checkbox', function(value) {
                    // Check if any checkbox in the specified range is checked (index 42 to 50)
                    const isChecked = Object.values(this.parent).slice(42, 51).some(val => val === true);                    
                    return isChecked; // Return true if any checkbox is checked
                });
                break;
              default:
                validator = Yup.string();
                break;
            }
          }
      
          // If the field is mandatory and has no dependent question, apply required validation
          if (field.mandatory === 1 && !field.depend_question) {
            validator = validator.required(`${field.question} is required`);
          }
      
          // If the field has a dependent question, apply conditional logic
          if (field.depend_question) {
            validator = validator.when(field.depend_question, {
              is: (val) => val === 'yes', // When dependent field is "yes"
              then: (schema) => schema.required(`${field.question} is required`), // Required if dependent is "yes"
              otherwise: (schema) => schema.notRequired(), // Not required if otherwise
            });
          }
      
          schema[field.question_no] = validator;
      
          return schema;
        }, {})
      );
      
    

      useEffect(() => {
        const savedData = JSON.parse(localStorage.getItem('formData')) || {}; // Get saved data from localStorage
        
            const formValues = {
                ...documents.reduce((acc, field) => {
                    acc[field.question_no] = savedData[field.question_no] || '';
                    return acc;
                }, {}),
                ...CheckBoxDocuments.reduce((acc, checkbox) => {
                    if (checkbox.isCustomInput) {
                        acc[checkbox.name] = savedData[checkbox.name] || '';
                    } else {
                        acc[checkbox.name] = savedData[checkbox.name] || false;
                    }
                    return acc;
                }, {}),
                undertaking: (savedData.undertaking || []).map(item => ({
                    undertaking: item.undertaking,
                    yes_no: item.yes_no || "No",  // Default to "No" if not defined
                })),
            };
    
            setInitialValues(formValues); // Set initial values from localStorage only
        
    }, []); 



    const formik = useFormik({
            initialValues: initialValues,

            validationSchema: modelSchema,
            enableReinitialize: true,
            onSubmit: async (values, { setSubmitting }) => {
                try {

                    const isCheckboxChecked = CheckBoxDocuments.some((checkbox) => values[checkbox.name]);
                    

                    if (!isCheckboxChecked) {
                        // Prevent form submission and scroll to the first unchecked checkbox
                        setSubmitting(false);

                        // Focus on the first unchecked checkbox
                        const firstUncheckedCheckbox = CheckBoxDocuments.find((checkbox) => !values[checkbox.name]);
                        if (firstUncheckedCheckbox) {
                        const checkboxElement = document.querySelector(`input[name="${firstUncheckedCheckbox.name}"]`);
                        if (checkboxElement) {
                            checkboxElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                            checkboxElement.focus(); // Focus the checkbox
                        }
                        }

                        return; // Stop further execution
                    }
                    // Convert the form data into a flat object
                    const tempData = {
                        ...documents.reduce((acc, field) => {
                            acc[field.question_no] = values[field.question_no];
                            return acc;
                        }, {}),
                        ...CheckBoxDocuments.reduce((acc, checkbox) => {
                          if (checkbox.isCustomInput) {
                              // If the checkbox has an associated input field, save the input field's value
                              acc[checkbox.name] = values?.[checkbox.name];
                          } else {
                              // For normal checkboxes, save "Yes" or "No"
                              acc[checkbox.name] = values?.[checkbox.name] ? 1 : 0;
                          }
                          return acc;
                        }, {}),
                        undertaking: values.undertaking,
                    };
                
                    // Retrieve existing data from localStorage
                    const existingData = JSON.parse(localStorage.getItem('formData')) || {};
                
                    // Merge new data with existing data
                    const updatedData = {
                        ...existingData,
                        ...tempData,
                        guidestar_number:gsnNoFromStorage,
                        audited_accounts: financialYearsData,
                    };
                    

                    const compare = {
                        guidestar_number: "1894",
                        legal_name_organisation: "Momscode",
                        email_id: "momscode@gmail.com",
                        organisation_it_pan: "ABCDE1234F",
                        contact_person_name: "Aswathi",
                        contact_persons__email_id: "aswathi@gmail.com",
                        contact_persons_number: "1234567890",
                        head_of_org_name: "Vijila CP",
                        head_of_org_email_id: "vijila@gmail.com",
                        contact_person_finance: "Manisha",
                        email_contact_person: "manisha@gmail.com",
                        contact_number_person: "5555555555",
                        transparency: 1,
                        donor_requirement: 0,
                        credibility: 1,
                        fundraising_donor: 1,
                        visibility: 0,
                        csr_corporate: 0,
                        organisation_development: 0,
                        other: "",
                        // change_in_registered_office:'',
                        // change_tax_deduction:'',
                        // key_laws:'',
                        apply_certification: "Yes",
                        specify_entity_name: "test",
                        certification_date: "2024-03-01",
                        know_about_gsi: "Email from GuideStar India",
                        other1: "",
                        audited_accounts: [
                            {
                                financial_year: "2020-21",
                                yes_no: "Yes"
                            },
                            {
                                financial_year: "2021-22",
                                yes_no: "Yes"
                            }
                        ],
                        financial_year: "2020-21",
                        annual_expenditure: "Rs. 123000",
                        year_of_registration: "1867",
                        valid_12a_reg: "No",
                        choose_option: "Basic KYC (Know Your Changemaker) Framework (you may qualify for Bronze Seal based on your certification score card)",
                        entity_reg: 1,
                        ngo_pan: 1,
                        physical_existence: 0,
                        existence_registration: 0,
                        org_current_valid: 0,
                        it_returns: 1,
                        org_aims: 0,
                        applicable_laws: 0,
                        org_registered_under_fcra: 0,
                        change_in_fcra: "Yes",
                        intimate_approve1: "Intimated",
                        change_in_pan: "No",
                        intimate_approve2: "",
                        tax_exemption: "Yes",
                        intimate_approve3: "Approved",
                        change_tax_deduction: "",
                        intimate_approve4: "",
                        change_registered_name: "",
                        intimate_approve5: "",
                        change_in_registered_office: "",
                        intimate_approve6: "",
                        change_in_deed: "",
                        intimate_approve7: "",
                        change_in_aoa: "",
                        intimate_approve8: "",
                        change_of_governing_body: "",
                        intimate_approve9: "",
                        key_laws: "",
                        intimate_approve11: "",
                        statutory_authorities: "",
                        intimate_approve12: "",
                        specify_activity: "",
                        intimate_approved13: "",
                        office_operation_activity: "",
                        intimate_approve14: "",
                        change_law: "",
                        intimate_approve15: "",
                        change_in_correspondence: "",
                        intimate_approve16: "",
                        change_chief_functionary: "",
                        intimate_approve17: "",
                        change_in_key_programmes: "",
                        intimate_approve18: "",
                        change_geographic_area: "",
                        intimate_approve19: "",
                        changes_impact_assessment: "",
                        intimate_approve20: "",
                        change_books_of_accounts: "",
                        intimate_approve21: "",
                        change_of_auditor: "",
                        intimate_approve22: "",
                        other_event: "",
                        choose_one_option: "We are depositing a cheque as the contribution from our donor",
                        org_auth: 1,
                        org_contribution: 0,
                        donor_foreigner: 1,
                        transfer_foreign_funds: 0,
                        name_person_filling_form: "Ranjana",
                        undertaking: [
                            {
                                undertaking: "We hereby certify that all the information provided in the GuideStar India Expression of Interest in Certification form as well as the information provided and documents submitted by my organisation on www.guidestarindia.org are true and correct.",
                                yes_no: "Yes"
                            },
                            {
                                undertaking: "We understand that only the application form submitted first will be reviewed. We may be certified the key/ badge/ seal of a lower category or may not get any certification, depending on the criteria complied with.",
                                yes_no: "Yes"
                            },
                            {
                                undertaking: "We understand that GuideStar India will provide training and capacity building support to undergo the due diligence process for certification. This comprises 3 telephonic/ online interactions, a help PPT and email support.",
                                yes_no: "Yes"
                            },
                            {
                                undertaking: "We understand that the GuideStar India Expression of Interest in Certification form is valid for 1 month and we will complete the documentation and required clarification within this period. There will be a maximum of 3 interactions for review of our application and the entire process is to be completed within a month after which our application will be cancelled automatically.",
                                yes_no: "Yes"
                            },
                            {
                                undertaking: "We understand that all information provided will be displayed on the GuideStar India website. We understand that GuideStar India will share the list of certified NGOs and information provided, with anyone interested in NGO information. Such information may be provided with or without cost to the person seeking the information.",
                                yes_no: "Yes"
                            },
                            {
                                undertaking: "We certify that our organisation has not been blacklisted by any donor/ funding agency/ grant making organisation/ statutory authority.",
                                yes_no: "Yes"
                            },
                            {
                                undertaking: "We hereby declare that our organisation is not blacklisted or rejected or subjected to any adverse action by any government department or by any government agency.",
                                yes_no: "Yes"
                            },
                            {
                                undertaking: "We hereby certify that our organisation does not employ or deal with any entities or individuals known by our organisation to support terrorism.",
                                yes_no: "Yes"
                            },
                            {
                                undertaking: "Our organisation has 12A registration under the Indian Income Tax Act, and it is currently valid.",
                                yes_no: "No"
                            },
                            {
                                undertaking: "Our organisation complies with all conditions stated in our 12A, 80G (if applicable), 35AC (if applicable) and FCRA (if applicable). We shall inform GuideStar India immediately in the event of any suspension/ cancellation.",
                                yes_no: "Yes"
                            },
                            {
                                undertaking: "Our organisation works in areas defined as 'charitable in nature' under the Indian Income Tax Act.",
                                yes_no: "Yes"
                            },
                            {
                                undertaking: "Our governing board ensures that all reporting requirements are met and are in compliance with the Societies Registration Act/ applicable Trust Act/ Indian Companies Act. Organisation has filed returns as specified by Act/Authorities applicable to it for the Financial year 2019-20 and 2018-19/ 2020-21 and 2019-20.",
                                yes_no: "Yes"
                            },
                            {
                                undertaking: "We hereby declare that our organisation is in compliance with all applicable laws including the Income Tax Act and FCRA.",
                                yes_no: "No"
                            },
                            {
                                undertaking: "We hereby declare that our organisation complies with its own rules & regulations as specified in its Trust Deed/ AOA/ MOA/ Constitution/ Bye Laws.",
                                yes_no: "Yes"
                            },
                            {
                                undertaking: "Our activities are in line with the Vision, Aim and Objectives of the organisation as stated in our Trust Deed/ MOA/ Constitution.",
                                yes_no: "Yes"
                            },
                            {
                                undertaking: "Our Governing Body composition is as per our Trust Deed/ AOA/ MOA/ Constitution and as per applicable laws.",
                                yes_no: "No"
                            },
                            {
                                undertaking: "We undertake to provide any clarification within one working day during the certification process.",
                                yes_no: "Yes"
                            },
                            {
                                undertaking: "We understand that the evaluation for the certification is an objective process. We understand that the decision of GuideStar India in all matters regarding the certification will be final and binding.",
                                yes_no: "Yes"
                            },
                            {
                                undertaking: "We understand that submission of the online form indicates that we have read these terms and conditions and have accepted them.",
                                yes_no: "No"
                            },
                            {
                                undertaking: "We hereby certify that all the information provided in the GuideStar India Expression of Interest in Certification form as well as the information provided and documents submitted by my organisation on www.guidestarindia.org are true and correct.",
                                yes_no: "Yes"
                            }
                        ]
                    };
                    
                    
                    // Creating a new object with keys from updatedData that match with compare
                    const newObject = Object.keys(updatedData).reduce((acc, key) => {
                        if (compare.hasOwnProperty(key)) {
                            acc[key] = updatedData[key];
                        }
                        return acc;
                    }, {});
                    
                    // Now you can use newObject as needed
                    // 

                        const structuredData = {
                            args: newObject
                        };
                
                    // Save updated data to localStorage
                    localStorage.setItem('formData', JSON.stringify(updatedData));                    
                

                    // Optionally, navigate to the next page or perform another action
                    await submitReg(structuredData);
                  } catch (error) {
                      console.error(error);
                  } finally {
                      setSubmitting(false);
                    //   localStorage.removeItem('formData')
                  }
            },
        });

        const handleCreateSuccess = () => {
            enqueueSnackbar('success!', { variant: 'success' });
            
        };
    
        const handleCreateError = (error) => {
            if (error?.response?.data.status_code >= 500) {
                enqueueSnackbar(error?.response?.data?.status_message, { variant: 'error' });
                
                
            } else {
                enqueueSnackbar(error?.response?.data?.message || error?.message, { variant: 'error' });
                
                
    
            }
        };
    
        const createFarmerMutationOptions = {
            onSuccess: handleCreateSuccess,
            onError: handleCreateError,
        };
    
        const {
            mutate: submitReg,
            data: regFinalData,
            // isPending: mainRegistration
        } = useMutation({
            mutationFn: ExpressionOfInterestRegistration,
            ...createFarmerMutationOptions,
        });

       

        const handleCheckboxChange = (e, index) => {
            const isChecked = e.target.checked;
        
            // Get the current `undertaking` array from Formik
            const updatedUndertakings = [...formik.values.undertaking];
        
            // Update the specific item based on index with the checked value
            updatedUndertakings[index] = {
                ...updatedUndertakings[index],  // Preserve the existing 'undertaking' text
                yes_no: isChecked ? 'Yes' : 'No' // Update 'yes_no' based on checkbox state
            };
        
            // Update the Formik field with the updated array
            formik.setFieldValue('undertaking', updatedUndertakings);
        };

  return (
    <>
        
            <form className='flex flex-col gap-[30px] ' action="" onSubmit={formik.handleSubmit}>

            <div className='flex flex-wrap gap-[30px] justify-between w-[100%]'>
                    {documents.slice(42, 44).map(Fields =>
                    <>
                    
                        <div className='w-[48%]'>
                            <CustomInput 
                                required
                                {...formik.getFieldProps(Fields.question_no)}
                                name={Fields.question_no} label={Fields.question}
                                onBlur={formik.handleBlur}  
                                disabled={true}
                            />
                            <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={formik.values?.[Fields.question_no] && formik.errors?.[Fields.question_no]} />
                            <ParagraphComp className='mt-[8px] text-[#5A5A5A] text-sm px-[8px]' text={Fields.description} />
                        </div>
                    </>
                    )}
                    {documents.slice(62, 64).map(Fields =>
                    <>
                    
                        <div className='w-[48%]'>
                            <CustomInput 
                                required
                                {...formik.getFieldProps(Fields.question_no)}
                                name={Fields.question_no} label={Fields.question}
                                onBlur={formik.handleBlur}  
                                disabled={true}
                            />
                            <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={formik.values?.[Fields.question_no] && formik.errors?.[Fields.question_no]} />
                            <ParagraphComp className='mt-[8px] text-[#5A5A5A] text-sm px-[8px]' text={Fields.description} />
                        </div>
                    </>
                    )}
                    
                </div >
                <div className=''>
                    <ParagraphComp className='text-2xl text-black' text='Contact information and other details. Please provide name and other details of the person who will  be interacting with GuideStar India for  the certification process' />
                </div>
                <div className='flex flex-wrap gap-[30px] justify-between w-[100%]'>
                    {documents.slice(44 , 47).map(Fields =>
                    <>
                    
                        <div className='w-[48%]'>
                            <CustomInput 
                                required
                                {...formik.getFieldProps(Fields.question_no)}
                                name={Fields.question_no} label={Fields.question}
                                onBlur={formik.handleBlur}  
                                
                            />
                            <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={formik.values?.[Fields.question_no] && formik.errors?.[Fields.question_no]} />
                            <ParagraphComp className='mt-[8px] text-[#5A5A5A] text-sm px-[8px]' text={Fields.description} />
                        </div>
                    </>
                    )}
                    
                </div >

                <ParagraphComp className='text-2xl text-black' text='Head of Organisation details' />
                <div className='flex flex-wrap gap-[30px] justify-between w-[100%]'>
                    {documents.slice(47, 49).map(Fields =>
                    <>
                    
                        <div className='w-[48%]'>
                            <CustomInput 
                                required
                                {...formik.getFieldProps(Fields.question_no)}
                                name={Fields.question_no} label={Fields.question}
                                onBlur={formik.handleBlur}  
                                disabled={Fields.disable}
                            />
                            <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={formik.values?.[Fields.question_no] && formik.errors?.[Fields.question_no]} />
                            <ParagraphComp className='mt-[8px] text-[#5A5A5A] text-sm px-[8px]' text={Fields.description} />
                        </div>
                    </>
                    )}
                    
                </div >
                <ParagraphComp className='text-2xl text-black' text='Finance/ Accounts team details' />
                <div className='flex flex-wrap gap-[30px] justify-between w-[100%]'>
                    {documents.slice(49,52).map(Fields =>
                    <>
                    
                        <div className='w-[48%]'>
                            <CustomInput 
                                required
                                {...formik.getFieldProps(Fields.question_no)}
                                name={Fields.question_no} label={Fields.question}
                                onBlur={formik.handleBlur}  
                            />
                            <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={formik.values?.[Fields.question_no] && formik.errors?.[Fields.question_no]} />
                            <ParagraphComp className='mt-[8px] text-[#5A5A5A] text-sm px-[8px]' text={Fields.description} />
                        </div>
                    </>
                    )}
                    
                </div >


                <div className=''>
          <ParagraphComp className='text-2xl text-black' text='Please let us know why you would like to undergo certification' />
        </div>

        <div className='w-[100%] flex gap-[24pt] flex-wrap'>
        
            {CheckBoxDocuments.slice(13).map((item, index) => (
            <div className='w-[35%] flex gap-[24pt]' key={index}>
              {!item.isCustomInput?
              <div className='w-[100%]'>
                <label className="flex items-center space-x-2">
                  <InputCompo 
                    className='bg-[#004878] text-white w-[20px] h-[20px]' 
                    type='checkbox' 
                    name={item.name}
                    checked={formik.values[item.name]} 
                    onChange={formik.handleChange} 
                    onBlur={formik.handleBlur} 
                  />
                  <span className='text-black'>{item.label}</span>
                </label>
                <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={formik.touched[item.name] && formik.errors[item.name]} />
              </div>
                :<>
                {item.isCustomInput && (
                  <div className='w-[100%]'>
                    <label className="flex items-center space-x-2">
                    <InputCompo 
                    className='bg-[#004878] text-white w-[20px] h-[20px]' 
                    type='checkbox' 
                    name={item.name}
                    checked={formik.values[item.name]} 
                    onChange={(e) => {
                        // Toggle the checkbox value
                        formik.setFieldValue(item.name, e.target.checked);
                        // Set the associated input to an empty string when the checkbox is checked
                        if (e.target.checked) {
                          formik.setFieldValue(item.name, "");
                        }
                        else{
                            formik.setFieldValue(item.name, "");
                        }
                      }}  
                    onBlur={formik.handleBlur} 
                  />
                      <CustomInput 
                         
                        {...formik.getFieldProps(item.name)} 
                        name={item.name} 
                        label={item.label} 
                        onBlur={formik.handleBlur} 
                      />
                    </label>
                    <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={formik.touched[item.name] && formik.errors[item.name]} />
                  </div>
                )}</>}
            </div>
          ))}
        </div>

        {/* <div className=''>
          <ParagraphComp className='font-bold text-lg' text='Awareness of GuideStar India' />
        </div> */}
        
        <div className='flex flex-wrap gap-[30px] justify-between w-[100%]'>
        
            {documents.slice(52 , 54).map(Fields => (
              <>
                {Fields.type.toLowerCase() === 'dropdown' ? (
                  <div className='w-[100%]' key={Fields.question_no}>
                    <CustomSelection 
                      required 
                      options={Fields?.options}
                      {...formik?.getFieldProps(Fields?.question_no)}
                      name={Fields.question_no} 
                      label={Fields.question}
                      noSort={true}
                    />
                    <ParagraphComp className='mt-[8px] text-[#5A5A5A] text-sm px-[8px]' text={Fields.description} />

                    {/* Check if 'Other' is selected, then display the text input */}
                    { formik.values.know_about_gsi === 'Other' && (
                      <div className='w-[100%]'>
                      {/* Render the 'Other (Please Specify)' text input */}
                      {documents.find(doc => doc.question_no === 'other1') && (
                        <CustomInput
                          required={formik.values.know_about_gsi === 'Other' ? true :false}
                          {...formik.getFieldProps('other1')}  
                          name="other1"
                          label="Other (Please Specify)"
                          onBlur={formik.handleBlur}
                        />
                      )}
                    </div>
                    )}
                  </div>
                ) : null}
              </>
            ))}
            {/* <div className=''>
              <ParagraphComp className='font-bold text-lg' text='Financial Readiness' />
            </div> */}
            <div className='w-[100%]'>
              <FinancialYearForm onFinancialYearsChange={handleFinancialYearsChange}/>
            </div>

            {documents.slice(54, 57).map(Fields =>
            <>
              {Fields.type.toLowerCase() === 'text' || Fields.type.toLowerCase() === 'number' || Fields.type.toLowerCase() === 'date' ?
                <div className='w-[100%]'>
                    <CustomInput 
                        required
                        {...formik.getFieldProps(Fields.question_no)}
                        name={Fields.question_no} label={Fields.question}
                        onBlur={formik.handleBlur}  
                    />
                    <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={formik.values?.[Fields.question_no] && formik.errors?.[Fields.question_no]} />
                    <ParagraphComp className='mt-[8px] text-[#5A5A5A] text-sm px-[8px]' text={Fields.description} />
                </div>
                :
                Fields.type.toLowerCase() === 'dropdown'
                    ?
                    <div className='w-[100%]'>
                        <>
                            <CustomSelection required options={Fields?.options}
                                {...formik?.getFieldProps(Fields?.question_no)}
                                name={Fields.question_no} label={Fields.question}
                                noSort={true}
                                disabled={Fields.disable}
                            />
                            {/* <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={TempFormik?.values?.[Fields.question_no] && TempFormik?.errors?.[Fields.question_no]} /> */}
                            <ParagraphComp className='mt-[8px] text-[#5A5A5A] text-sm px-[8px]' text={Fields.description} />                                        </>
                    </div>
                    :''
                }
            </>
            )}
            {documents.slice(57, 61).map(Fields =>
            <>
              
                {Fields.type.toLowerCase() === 'dropdown'
                    ?
                    <div className='w-full'>
                        <>
                            <CustomSelection required options={Fields?.options}
                                {...formik?.getFieldProps(Fields?.question_no)}
                                name={Fields.question_no} label={Fields.question}
                                noSort={true}
                                disabled={Fields.disable}
                            />
                            {/* <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={TempFormik?.values?.[Fields.question_no] && TempFormik?.errors?.[Fields.question_no]} /> */}
                            <ParagraphComp className='mt-[8px] text-[#5A5A5A] text-sm px-[8px]' text={Fields.description} />                                        </>
                    </div>
                    :Fields.type.toLowerCase() === 'date' ? (
                      <div className='w-[100%]'>
                        <CustomInput 
                          required={Fields.mandatory === 1}
                          {...formik.getFieldProps(Fields.question_no)}
                          name={Fields.question_no}
                          label={Fields.question}
                          onBlur={formik.handleBlur}  
                          type={Fields.type}
                          disabled={true}
                        />
                        <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={formik.values?.[Fields.question_no] && formik.errors?.[Fields.question_no]} />
                        <ParagraphComp className='mt-[8px] text-[#5A5A5A] text-sm px-[8px]' text={Fields.description} />
                      </div>
                      )
                    :''
                }
                {formik.values?.apply_certification === 'Yes' && Fields.depend_question === 'apply_certification' && (
                <>
                  {Fields.type.toLowerCase() === 'text' || Fields.type.toLowerCase() === 'number' || Fields.type.toLowerCase() === 'date' ?
                    <div className='w-[100%]'>
                        <CustomInput
                            required
                            {...formik.getFieldProps(Fields.question_no)}
                            name={Fields.question_no}
                             label={Fields.question} 
                             type={Fields.type}
                            onBlur={formik.handleBlur}
                            
                        />
                        <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={formik.values?.[Fields.question_no] && formik.errors?.[Fields.question_no]} />
                        <ParagraphComp className='mt-[8px] text-[#5A5A5A] text-sm px-[8px]' text={Fields.description} />
                    </div>:''}
                </>
              )}
            </>
            )} 

            {documents.slice(61, 62).map(Fields =>
                    <>
                        {Fields.type.toLowerCase() === 'text' || Fields.type.toLowerCase() === 'number' || Fields.type.toLowerCase() === 'date' ?
                            <div className='w-[100%]'>
                                <CustomInput
                                    required
                                    {...formik.getFieldProps(Fields.question_no)}
                                    name={Fields.question_no} 
                                    label={Fields.question} 
                                    type={Fields.type}
                                    onBlur={formik.handleBlur}
                                    allowFutureDates={true}
                                    allowOnlyFutureDates = {true} 
                                />
                                <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={formik.values?.[Fields.question_no] && formik.errors?.[Fields.question_no]} />
                                <ParagraphComp className='mt-[8px] text-[#5A5A5A] text-sm px-[8px]' text={Fields.description} />
                            </div>
                            
                                : ''
                        }
                    </>
                )}            
          </div >













                

                {documents.slice(0, 1).map(Fields =>
                    <>
                        {Fields.type.toLowerCase() === 'dropdown'
                            ?
                            <div className='w-[100%]'>
                                <>
                                    <CustomSelection required options={Fields?.options}
                                        {...formik?.getFieldProps(Fields?.question_no)}
                                        name={Fields.question_no} label={Fields.question}
                                        noSort={true}
                                    />
                                    {/* <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={TempFormik?.values?.[Fields.question_no] && TempFormik?.errors?.[Fields.question_no]} /> */}
                                    <ParagraphComp className='mt-[8px] text-[#5A5A5A] text-sm px-[8px]' text={Fields.description} />                                        </>
                            </div>
                            : ''
                        }
                    </>
                )}
                <div className='flex flex-col gap-[24px] '>
                    {/* <div className=''>
                        <ParagraphComp className='font-bold text-lg' text='Eligibility Criteria' />
                    </div> */}
                    <div className=''>
                        <ParagraphComp className=' text-2xl text-black ' text='Please tick whichever is true in the case of your organization' />
                    </div>
                    <div className=''>
                        <ParagraphComp className=' text-[black] text-md ' text='Your answers to the below will determine your eligibility for the level of certification.' />
                    </div>
                </div>
                {CheckBoxDocuments?.slice(0, 9).map(Field => {
                    // Determine if any checkbox is checked
                    // const isChecked = Object.values(formik.values).slice(42, 51).some(value => value === true);                    

                    return (
                        <label className="flex items-center space-x-2">
                            <InputCompo 
                                className='bg-[#004878] flex-shrink-0 text-white w-[20px] h-[20px]'
                                type='checkbox'
                                name={Field.name}
                                checked={formik.values[Field.name]}
                                onChange={formik.handleChange}
                                // required={!isChecked} // Only mark required if no checkbox is checked
                            />
                            <span className='text-black text-wrap leading-9'>{Field.text}</span>
                        </label>
                    );
                })}

            {
            /* <div className='h-[1px] bg-slate-300'></div>
            <div className=''>
                <ParagraphComp className='font-bold text-lg' text='Material Changes' />
            </div> */}
            <div className=''>
                <ParagraphComp className='text-2xl text-black' text='List of Material Changes during FY under review and subsequently – indicate change and the supporting doc, whether intimated/ approved' />
            </div>
           
            <div className='flex flex-wrap gap-[30px] justify-between w-[100%]'>
                {documents?.slice(1, 40).map((field, index) => (
                    <React.Fragment key={field.question_no}>
                        {/* Handle Dropdowns */}
                        {field.type.toLowerCase() === 'dropdown' && !field.depend_question ? (
                            <div className='w-[47%]'>
                                <CustomSelection 
                                    required 
                                    options={field.options}
                                    {...formik.getFieldProps(field.question_no)}
                                    name={field.question_no}
                                    label={field.question}
                                    noSort={true}
                                />
                                <ParagraphComp className='mt-[8px] text-[#5A5A5A] text-sm px-[8px]' text={field.description} />
                            </div>
                        ) : (
                            formik.values[field.depend_question] === 'Yes' && (
                                <div className='w-[47%]'>
                                    <CustomSelection  
                                        options={field.options}
                                        {...formik.getFieldProps(field.question_no)}
                                        name={field.question_no}
                                        label={field.question}
                                    />
                                    <ParagraphComp className='mt-[8px] text-[#5A5A5A] text-sm px-[8px]' text={field.description} />
                                </div>
                            )
                        )}

                            {/* Handle Text, Number, Date inputs */}
                            {(field.type.toLowerCase() === 'text' || field.type.toLowerCase() === 'number' || field.type.toLowerCase() === 'date') && (
                                <div className='w-[100%]'>
                                    <CustomInput
                                        required
                                        {...formik.getFieldProps(field.question_no)}
                                        name={field.question_no}
                                        label={field.question}
                                        onBlur={formik.handleBlur}
                                    />
                                    <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={formik.values?.[field.question_no] && formik.errors?.[field.question_no]} />
                                    <ParagraphComp className='mt-[8px] text-[#5A5A5A] text-sm px-[8px]' text={field.description} />
                                </div>
                            )}
                        </React.Fragment>
                    ))}
                </div>


            {/* <div className='h-[1px] bg-slate-300'></div>
            <div className=''>
                <ParagraphComp className='font-bold text-lg' text='Cost of certification' />
            </div> */}
            {documents?.slice(40, 41).map(Fields =>
                <>
                    {Fields.type.toLowerCase() === 'dropdown'
                            ?
                            <div className='w-[100%]'>
                                <>
                                    <CustomSelection required options={Fields?.options}
                                        {...formik?.getFieldProps(Fields?.question_no)}
                                        name={Fields.question_no} label={Fields.question}
                                        noSort={true}
                                    />
                                    {/* <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={TempFormik?.values?.[Fields.question_no] && TempFormik?.errors?.[Fields.question_no]} /> */}
                                    <ParagraphComp className='mt-[8px] text-[#5A5A5A] text-sm px-[8px]' text={Fields.description} />                                        </>
                            </div>
                            : ''}
                    </>
                )}

                {/* <div className='h-[1px] bg-slate-300'></div>
                <div className=''>
                    <ParagraphComp className='font-bold text-lg' text='Acknowledgeable' />
                </div> */}
                <div className=''>
                    <ParagraphComp className='text-2xl text-black' text='Tick all those that are applicable' />
                </div>

                {CheckBoxDocuments?.slice(9, 13).map(Field =>
                    <>
                        <label className="flex items-start space-x-2">
                            <InputCompo className='bg-[#004878] flex-shrink-0 text-white w-[20px] h-[20px]' type='checkbox' />
                            <span className='text-black text-wrap '>{Field.text}</span>
                        </label>
                    </>
                )}

            {documents?.slice(41 , 42).map(Fields =>
            <>
                {Fields.type.toLowerCase() === 'text' || Fields.type.toLowerCase() === 'number' || Fields.type.toLowerCase() === 'date' ?
                <div className='w-[100%]'>
                    <CustomInput 
                        required
                        {...formik.getFieldProps(Fields.question_no)}
                        name={Fields.question_no} label={Fields.question}
                        onBlur={formik.handleBlur}  
                    />
                    <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={formik.values?.[Fields.question_no] && formik.errors?.[Fields.question_no]} />
                    <ParagraphComp className='mt-[8px] text-[#5A5A5A] text-sm px-[8px]' text={Fields.description} />
                </div>
                :''}
            </>
            )}

                <div className='h-[1px] bg-slate-300'></div>


            <div className=''>
                <ParagraphComp className='text-2xl text-black' text='Undertaking' />
            </div>
            <div className='p-[16px] rounded-[8px] bg-[#EFEFEF] flex flex-col gap-[20px]'>
                {/* {para?.map((item, index) => (
                    <ParagraphComp key={index} className='text-[black] text-md' text={item} />
                ))}
                <label className="flex items-center space-x-2">
                    <InputCompo
                        className='bg-[#004878] text-white w-[20px] h-[20px]'
                        type="checkbox"
                        id="agreeCheckbox"
                        name="agreeCheckbox"
                        checked={formik.values.agreeCheckbox}  // Use boolean directly
                        onChange={handleCheckboxChange}
                    />
                    <span className='text-black'>I Agree</span>
                </label> */}
                {para?.map((item, index) => (
                    <div key={index} className="flex items-start gap-2">
                        <label className="flex items-center space-x-2">
                            <InputCompo
                                className="bg-[#004878] text-white w-[20px] h-[20px]"
                                type="checkbox"
                                name={`undertaking[${index}].yes_no`}  // Use index to target specific checkbox
                                checked={formik.values.undertaking?.[index]?.yes_no === 'Yes'}  // Set checked based on value
                                onChange={(e) => handleCheckboxChange(e, index)}  // Pass index to handleCheckboxChange
                            />
                        </label>
                        {/* Display the corresponding undertaking text */}
                        <ParagraphComp className="text-black text-md" text={item.undertaking} />
                    </div>
                ))}
            </div>

            {documents?.slice(42 , 43).map(Fields =>
            <>
                {Fields.type.toLowerCase() === 'dropdown' ?
                <div className='w-[100%]'>
                    <CustomSelection required options={Fields?.options}
                        {...formik?.getFieldProps(Fields?.question_no)}
                        name={Fields.question_no} label={Fields.question}
                        noSort={true}
                    />
                    {/* <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={TempFormik?.values?.[Fields.question_no] && TempFormik?.errors?.[Fields.question_no]} /> */}
                    <ParagraphComp className='mt-[8px] text-[#5A5A5A] text-sm px-[8px]' text={Fields.description} />
                </div>
                :''}
            </>
            )}



                <div className='flex justify-end'>
                    <div className='flex gap-[20px]'>
                        {/* <ButtonComp text={'Save'}  className='px-[20px] rounded-full border-1 border-[#004878] text-[#004878] py-[10px]' /> */}
                        <ButtonComp text={'Save'} type={'submit'} className='px-[20px] rounded-full bg-[#004878] text-[white] py-[10px]' />
                    </div>
                </div>
            </form>
        </>
  )
}

export default AddEOI